import { UserChangePreference } from '../types/changeTracking';

export interface UpdatePreferenceData {
  entity_types?: string[] | null;
  change_types?: string[] | null;
  severity_levels?: string[] | null;
  enabled?: boolean;
}

export interface BulkUpdatePreferencesData {
  preferences: Array<{
    notificationType: 'email' | 'in_app' | 'sms' | 'push';
    data: UpdatePreferenceData;
  }>;
}

class ChangePreferencesApi {
  private baseUrl = '/api/user/change-preferences';

  async getUserPreferences(): Promise<UserChangePreference[]> {
    const response = await fetch(this.baseUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to get user preferences');
    }

    const result = await response.json();
    return result.data;
  }

  async updateUserPreferences(data: BulkUpdatePreferencesData): Promise<UserChangePreference[]> {
    const response = await fetch(this.baseUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to update user preferences');
    }

    const result = await response.json();
    return result.data;
  }

  async resetToDefaults(): Promise<UserChangePreference[]> {
    const response = await fetch(`${this.baseUrl}/reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to reset preferences to defaults');
    }

    const result = await response.json();
    return result.data;
  }

  async getPreference(notificationType: string): Promise<UserChangePreference> {
    const response = await fetch(`${this.baseUrl}/${notificationType}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to get preference');
    }

    const result = await response.json();
    return result.data;
  }

  async updatePreference(notificationType: string, data: UpdatePreferenceData): Promise<UserChangePreference> {
    const response = await fetch(`${this.baseUrl}/${notificationType}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to update preference');
    }

    const result = await response.json();
    return result.data;
  }
}

export const changePreferencesApi = new ChangePreferencesApi();